// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableVoucherCampaign_Component__1FxE9"};